import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl';
import { InView } from 'react-intersection-observer';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashCan } from '@fortawesome/free-solid-svg-icons';


import { getWishlistFriends, clearFriendsList } from 'Redux/ducks/wishlist';
import { history } from 'Redux/store';
import { indexAlgoliaName } from 'Redux/ducks/algolia-calls';
import Backtotopbutton from 'Components/Utility/Mobile/Backtotopbutton';
import getUrlParameter from 'Helpers/Url/GetUrlParameter';
import LazyModal from 'Components/Utility/LazyModal';
import MessageBox from 'Components/Utility/MessageBox';
import Meta from 'Components/Utility/SEO/Meta';
import MyFriendWishlistContainer from 'Containers/Wishlist/MyFriendsWishlistContainer';
import MyWishlistContainer from 'Containers/Wishlist/MyWishlistContainer';
import NoIndex from 'Components/Utility/SEO/NoIndex';
import WishlistSyncBanner from 'Components/Wishlist/WishlistSyncBanner';
import WishlistEmptyModal from 'Containers/Wishlist/WishlistEmptyModal';
import WishlistSortDropDown from 'Components/Wishlist/WishlistSortDropDown';
import WishlistShareButton from 'Components/Wishlist/WishlistShareButton';
import useViewport from 'Hooks/useViewport';


import 'Components/Account/AccountPage.scss';
import 'Components/Account/Wishlist/AccountWishlist.scss';
import 'Components/Wishlist/Wishlist.scss';

const messages = defineMessages({
  title: {
    id: 'wishlist.title',
    defaultMessage: 'Your Wishlist',
  },
  recommended_for: {
    id: 'wishlist.recommededforyou',
    defaultMessage: 'Recommended For You',
  },
  added_to_wishlist: {
    id: 'wishlist.addedtowishlist',
    defaultMessage: 'has been added to your Wishlist.',
  },
});

const WishlistContainer = ({
  match,
  authWishlistId,
  intl: { formatMessage },
  getWishlistFriends: propGetWishlistFriends,
  authenticated,
  fromAccount,
  wishlistItemCount,
}) => {
  const [open, setOpen] = useState(false);
  const indexName = indexAlgoliaName;

  const wishlistSort = localStorage.getItem('wishlistSort') || indexName;
  const addToWishlistSlug = getUrlParameter('add_to_wishlist') || '';
  const tabParam = getUrlParameter('tab') || '';
  const wishlistId = match.params.wishlistId;


  let defaultTab = 'MyWishlist';
  if (wishlistId || (tabParam === 'friends')) {
    defaultTab = 'MyFriends';
  }

  const [sort, setSort] = useState(wishlistSort);
  const [tab, setTab] = useState(defaultTab);
  const [privateWishlist, setPrivateWishlist] = useState(false);
  const [emptyWishlist, setEmptyWishlist] = useState(false);

  const hideActions = (tabParam === 'friends' && !wishlistId) || privateWishlist || emptyWishlist;

  useEffect(() => {
    const loadWishlistFriends = async () => {
      await propGetWishlistFriends();
    };

    if (authWishlistId === wishlistId) {
      history.push({ pathname: '/wishlist' });
    }
    if (authenticated) loadWishlistFriends();
    if (!authenticated) clearFriendsList();
  }, [authWishlistId, wishlistId, authenticated, propGetWishlistFriends]);

  const changeSort = (value) => {
    if (!value) return;

    localStorage.setItem('wishlistSort', value);
    setSort(value);
  };

  const myWishlistTabClick = () => {
    setTab('MyWishlist');
    history.push({
      pathname: fromAccount ? '/account/wishlist' : '/wishlist',
    });
  };

  const myFriendsTabClick = () => {
    setTab('MyFriends');
    history.push({
      pathname: fromAccount ? '/account/wishlist' : '/wishlist',
      search: '?tab=friends',
    });
  };

  let itemAdding = '';
  itemAdding = addToWishlistSlug.replace(/-/g, ' ');

  const { isBelowMd } = useViewport();

  return (
    <React.Fragment>
      <LazyModal
        centered
        open={open}
        setOpen={setOpen}
        className="account-modal"
      >
        <WishlistEmptyModal setOpen={setOpen} />
      </LazyModal>

      <div className={classNames('container pb-5', { 'wishlist-account-container': fromAccount })}>
        <Meta brandTitle title={formatMessage(messages.title)} />
        <NoIndex allowRender />
        <div className="wishlist-container">
          <div className={classNames('wishlist', { 'wishlist-account': fromAccount })}>
            <section className={classNames({ 'account-content': fromAccount })}>
              <WishlistSyncBanner />

              <InView>
                {({ inView, ref }) =>
                  <div ref={ref}>
                    <div className="wishlist-top-bar">
                      <div>
                        <h1>
                          <FormattedMessage id="wishlist.wishlist" defaultMessage="Wishlist" />
                        </h1>
                        {!authenticated &&
                          <p className="seo-blurb-text mb-0">
                            <FormattedMessage id="wishlist.anonwishlistmessage" defaultMessage="Login in or register to save items to your account and access them from everywhere" />
                          </p>
                        }
                      </div>

                      <WishlistShareButton />
                    </div>

                    {!inView &&
                      <div className="d-block d-sm-none">
                        <Backtotopbutton />
                      </div>
                    }
                  </div>
                }
              </InView>

              <div className="wishlist-filters">
                <div className="wishlist-filters-mywishlist-myfriends">
                  <button className={classNames('pill-filter-container', { selected: tab === 'MyWishlist' })} onClick={() => myWishlistTabClick()}>
                    <FormattedMessage id="wishlist.yourwishlist" defaultMessage="My Wishlist" />
                  </button>
                  {authenticated &&
                    <button className={classNames('pill-filter-container', { selected: tab === 'MyFriends' })} onClick={() => myFriendsTabClick()}>
                      <FormattedMessage id="wishlist.myfriends" defaultMessage="My Friends" />
                    </button>
                  }
                </div>

                {!hideActions &&
                  <div className="wishlist-filters-sortby-delete">
                    <WishlistSortDropDown sort={sort} onSortChange={changeSort} />
                    {tab === 'MyWishlist' && authenticated && (wishlistItemCount > 4 || isBelowMd) &&

                      <button className="wishlist-delete-all-btn btn-reset-style" onClick={() => setOpen(true)}>
                        <FontAwesomeIcon icon={faTrashCan} />
                        <FormattedMessage id="wishlist.deleteall" defaultMessage="Delete All" />
                      </button>
                    }
                  </div>
                }
              </div>

              {itemAdding &&
                <div className="mb-4">
                  <MessageBox
                    type="success"
                    message={`<span class="item-adding">${itemAdding}</span> ${formatMessage(messages.added_to_wishlist)}`}
                  />
                </div>
              }

              {tab === 'MyFriends' ?
                <MyFriendWishlistContainer
                  fromAccount={fromAccount}
                  wishlistId={wishlistId}
                  sort={sort}
                  setPrivateWishlist={setPrivateWishlist}
                />
                :
                <MyWishlistContainer
                  fromAccount={fromAccount}
                  sort={sort}
                  setEmptyWishlist={setEmptyWishlist}
                  onSortChange={changeSort}
                />
              }
            </section>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

WishlistContainer.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      wishlistId: PropTypes.string,
    }),
  }).isRequired,
  authWishlistId: PropTypes.string,
  authenticated: PropTypes.bool,
  getWishlistFriends: PropTypes.func.isRequired,
  fromAccount: PropTypes.bool,
  wishlistItemCount: PropTypes.number,
};

WishlistContainer.defaultProps = {
  authWishlistId: '',
  authenticated: false,
  search: '',
  fromAccount: false,
  wishlistItemCount: null,
};

const mapStateToProps = ({
  auth: { wishlist_id: authWishlistId, authenticated, language },
  router: { location: { search } },
  wishlist: { count: wishlistItemCount },
}) => ({
  authWishlistId,
  authenticated,
  language,
  search,
  wishlistItemCount,
});

const mapDispatchToProps = {
  getWishlistFriends,
};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(WishlistContainer));
